/**
 * @fileoverview French translations.
 * @package PlayItNow
 * @module apps/front/lib/i18n/locales/fr
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

export const fr = {
  login: {
    title: 'Connexion',
    subtitle: 'Connectez-vous à votre espace administrateur de groupe',
    emailLabel: 'Email ou identifiant',
    emailPlaceholder: "votre@email.com ou nom d'utilisateur",
    passwordLabel: 'Mot de passe',
    passwordPlaceholder: '••••••••',
    submitButton: 'Se connecter',
    submitting: 'Connexion...',
    forgotPassword: 'Mot de passe oublié ?',
    noAdminRights: "Vous n'avez pas les droits d'administration",
    errorGeneric: 'Une erreur est survenue lors de la connexion',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
  },
  auth: {
    optional: 'optionnel',
  },
  home: {
    title: 'Votez pour vos morceaux préférés lors de concerts live !',
    wantToVote: 'Je veux voter',
    wantToVoteDescription: 'Créez un compte gratuit pour voter lors des concerts',
    wantToManageBand: 'Je gère mon groupe',
    wantToManageBandDescription: 'Créez un compte pour gérer vos événements et morceaux',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
  },
  landing: {
    languageLabel: 'Choisir sa langue',
    heroTitle: 'Laissez le public choisir le prochain morceau de votre setlist',
    heroSubtitle:
      'Composez votre setlist. Les spectateurs scannent un QR code et votent pour le prochain titre en direct. Une expérience unique à chaque concert.',
    ctaPrimary: 'Créer mon compte groupe — essai gratuit',
    whyTitle: 'Pourquoi PlayItNow ?',
    benefit1Title: 'Un QR code, le public vote',
    benefit1Desc: 'Vos spectateurs scannent, votent pour leurs morceaux préférés depuis leur téléphone. Plus d’interactivité.',
    benefit2Title: 'Classement en direct',
    benefit2Desc: 'Les votes s’affichent en direct. Vous enchaînez les titres les plus demandés sur scène.',
    benefit3Title: 'Simple pour les groupes',
    benefit3Desc: 'Créez vos événements, gérez votre setlist, lancez le vote en un clic. Tarifs adaptés aux artistes.',
    twoWaysTitle: 'Deux façons de vivre PlayItNow',
    ctaBand: 'Je suis un groupe',
    ctaBandDesc: 'Créez des événements, ajoutez vos morceaux, laissez le public voter en direct.',
    ctaFan: 'Je suis spectateur',
    ctaFanDesc: 'Rejoignez un concert via QR code et votez pour les morceaux que vous voulez entendre.',
    alreadyAccount: 'Déjà un compte ?',
    login: 'Connexion',
    learnMore: 'Voir les événements',
  },
  public: {
    login: {
      title: 'Connexion',
      subtitle: 'Votez pour vos morceaux préférés !',
      subtitle2: 'Les titres gagnants seront joués en live !',
      identifyTitle: 'Identifiez-vous',
      identifySubtitle: 'Votez pour choisir le prochain morceau du concert !',
      emailLabel: 'Email ou identifiant',
      emailPlaceholder: "votre@email.com ou nom d'utilisateur",
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: '••••••••',
      submitButton: 'Se connecter',
      submitting: 'Connexion...',
      loading: 'Chargement...',
      withoutRegistration: 'Accéder aux votes',
      or: 'OU',
      errorGeneric: 'Une erreur est survenue',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      firstNameLabel: 'Votre prénom (optionnel)',
      firstNamePlaceholder: 'Jean',
      firstNameHint: 'Votre prénom sera affiché lors de vos votes',
      haveAccount: "J'ai un compte",
      forgotPassword: 'Mot de passe oublié ?',
      createAccount: 'Je crée un compte (gratuit)',
      pinDataHub: 'Je gère mon groupe',
      orDivider: 'ou',
      loginWithGoogle: 'Se connecter avec Google',
      loginWithFacebook: 'Se connecter avec Facebook',
      oauthNoAccount: 'Aucun compte associé à ce profil. Choisissez « Compte fan » ou « Compte groupe » sur la page d’accueil puis continuez avec Google ou Facebook.',
      oauthFailed: 'La connexion avec ce fournisseur a échoué. Réessayez.',
      oauthNoEmail: "Facebook n'a pas fourni d'adresse email. Vérifiez les autorisations ou utilisez un compte avec email, ou inscrivez-vous avec Google.",
      oauthUnavailable: 'La connexion avec ce fournisseur est temporairement indisponible.',
      oauthUseProvider: 'Utilisez Google ou Facebook pour vous connecter.',
      oauthCompleteEmailTitle: 'Facebook n’a pas partagé votre email',
      oauthCompleteEmailDescription: 'Saisissez votre adresse email pour terminer la connexion.',
      oauthCompleteEmailSubmit: 'Terminer la connexion',
      oauthCompleteEmailPlaceholder: 'votre@email.com',
      oauthCompleteEmailExpired: 'Session expirée. Réessayez la connexion avec Facebook.',
      oauthCompleteEmailNoAccount: 'Choisissez d’abord un type de compte (fan ou groupe) depuis la page d’accueil.',
    },
    register: {
      title: 'Créer un compte',
      subtitle: 'Rejoignez la communauté PlayItNow',
      firstNameLabel: 'Prénom',
      firstNamePlaceholder: 'Jean',
      lastNameLabel: 'Nom',
      lastNamePlaceholder: 'Dupont',
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      usernameLabel: "Nom d'utilisateur",
      usernamePlaceholder: 'jean.dupont',
      autoGenerated: 'Généré automatiquement',
      usernameHint: "Vous pouvez modifier ce nom d'utilisateur",
      submitButton: 'Créer mon compte',
      submitting: 'Création du compte...',
      backToLogin: 'Retour à la connexion',
      orDivider: 'ou',
      continueWithGoogle: 'Continuer avec Google',
      continueWithFacebook: 'Continuer avec Facebook',
      successTitle: 'Inscription réussie !',
      successMessage:
        'Un email de confirmation vous a été envoyé. Vérifiez votre boîte de réception pour activer votre compte.',
      error: {
        firstNameRequired: 'Le prénom est requis',
        lastNameRequired: 'Le nom est requis',
        emailRequired: "L'email est requis",
        generic: 'Une erreur est survenue lors de la création du compte',
      },
      // Band registration fields
      bandNameLabel: 'Nom du groupe',
      bandNamePlaceholder: 'Nom de votre groupe',
      passwordLabel: 'Mot de passe',
      passwordPlaceholder: '••••••••',
      passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
      logoUrlLabel: 'URL du logo (optionnel)',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
    },
    events: {
      title: 'Événements à venir',
      noEvents: 'Aucun événement à venir',
      noEventsDescription: "Il n'y a pas d'événements prévus dans les 2 prochains jours.",
      errorLoad: 'Erreur lors du chargement des événements',
      settings: 'Paramètres',
      logout: 'Quitter',
    },
    event: {
      invalidSlug: "Slug d'événement invalide",
      notFound: 'Événement introuvable',
      errorLoad: "Erreur lors du chargement de l'événement",
      backToEvents: 'Retour aux événements',
      songsTitle: 'Morceaux disponibles',
      noSongs: 'Aucun morceau disponible pour le moment',
      vote: 'Voter',
      voted: 'Voté',
      loading: 'Chargement...',
      votesRemaining: 'Votes restants',
      voteSuccess: 'Votre vote a été enregistré !',
      voteError: "Erreur lors de l'enregistrement du vote",
      totalVotes: 'Total des votes',
      votesLabel: 'votes',
      blindVoteMessage: 'Le classement sera révélé par le groupe.',
      rankingTitle: 'Classement',
      votingPaused: 'Les votes sont actuellement suspendus.',
      votingCompleted: 'Cet événement est terminé. Les votes sont fermés.',
      settings: 'Paramètres',
      logout: 'Quitter',
    },
    qrCode: {
      title: 'Partager cet événement',
      description: "Scannez ce code QR ou partagez le lien pour inviter d'autres personnes à voter",
      share: 'Partager',
      copy: 'Copier le lien',
      show: 'Afficher le QR code',
      shareText: 'Rejoignez-moi pour voter sur les morceaux de {{eventName}} !',
    },
    settings: {
      title: 'Paramètres du compte',
      account: 'Compte',
      email: 'Email',
      username: "Nom d'utilisateur",
      firstName: 'Prénom',
      lastName: 'Nom',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      success: 'Paramètres enregistrés avec succès',
      error: "Erreur lors de l'enregistrement",
      password: {
        title: 'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Nouveau mot de passe',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Confirmer le nouveau mot de passe',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Changer le mot de passe',
        changing: 'Changement en cours...',
        success: 'Mot de passe changé avec succès. Veuillez vous reconnecter.',
        error: 'Erreur lors du changement de mot de passe',
        mismatch: 'Les mots de passe ne correspondent pas',
        incorrect: 'Le mot de passe actuel est incorrect',
      },
      deleteAccount: {
        title: 'Supprimer le compte',
        description: 'La suppression de votre compte est définitive et irréversible.',
        button: 'Supprimer mon compte',
        confirming: 'Confirmation...',
        confirmTitle: 'Confirmer la suppression',
        confirmMessage:
          'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
        confirmButton: 'Oui, supprimer',
        cancelButton: 'Annuler',
        success: 'Compte supprimé avec succès',
        error: 'Erreur lors de la suppression du compte',
      },
    },
    dataExport: {
      title: 'Export de vos données',
      description:
        "Conformément au RGPD, vous pouvez demander l'export de toutes vos données personnelles stockées sur PlayItNow.",
      whatIncluded: "L'export inclura :",
      included: {
        profile: 'Vos informations de profil (email, nom, prénom, etc.)',
        votes: 'Votre historique de votes',
        preferences: 'Vos préférences (thème, langue)',
        sessions: 'Vos sessions de connexion',
      },
      exportButton: 'Exporter mes données',
      exporting: 'Export en cours...',
      success: 'Vos données ont été exportées avec succès. Le téléchargement va commencer.',
      error: "Une erreur est survenue lors de l'export de vos données.",
      note: "Note : L'export de vos données peut prendre quelques instants. Le fichier sera au format JSON.",
    },
  },
  legal: {
    title: 'Mentions légales',
    editor: {
      title: 'Éditeur',
      name: 'axialdata',
      email: 'Email : contact@axialdata.net',
      siret: 'SIRET : 49347625300023',
    },
    publication: {
      title: 'Directeur de la publication',
      director: 'Pierre-Yves Léglise',
    },
    hosting: {
      title: 'Hébergeur',
      name: 'Hostinger International Ltd',
      addressLine1: 'L’application est hébergée en France (centre de données Paris).',
      addressLine2: 'Siège social : Švitrigailos g. 34, LT-03230 Vilnius, Lituanie',
      country: 'Lituanie',
      url: 'https://www.hostinger.com',
    },
    dataProtection: {
      title: 'Protection des données',
      description:
        'Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez de droits sur vos données personnelles.',
      link: 'Consulter notre politique de confidentialité',
    },
  },
  privacy: {
    title: 'Politique de confidentialité',
    lastUpdated: 'Dernière mise à jour : octobre 2025',
    intro: {
      title: 'Introduction',
      description:
        "PlayItNow s'engage à protéger votre vie privée et vos données personnelles. Cette politique explique comment nous collectons, utilisons et protégeons vos informations.",
    },
    dataCollection: {
      title: 'Données collectées',
      bands: {
        title: 'Pour les groupes (clients payants)',
        email: 'Adresse email',
        username: "Nom d'utilisateur",
        name: 'Nom du groupe et informations de contact',
        payment: 'Informations de paiement (via prestataire tiers sécurisé)',
        logo: 'Logo du groupe',
      },
      spectators: {
        title: 'Pour les spectateurs (utilisateurs gratuits)',
        email: 'Adresse email (si création de compte)',
        firstName: 'Prénom (optionnel, pour affichage lors des votes)',
        fingerprint: 'Empreinte numérique du navigateur (anti-fraude)',
        ip: 'Adresse IP (pour sécurité et audit)',
        votes: 'Historique des votes effectués',
      },
    },
    purposes: {
      title: 'Finalités du traitement',
      authentication: 'Authentification et gestion des comptes utilisateurs',
      voting: 'Gestion du système de vote interactif',
      fraud: 'Prévention de la fraude et sécurisation des votes',
      billing: 'Facturation et gestion des abonnements (groupes uniquement)',
      support: 'Support client et assistance technique',
      preferences: 'Mémorisation des préférences utilisateur (thème, langue)',
      analytics: 'Mesure d\'audience du site (Rybbit auto-hébergé, à usage interne : pages vues, provenance ; aucune donnée revendue ni cédée)',
    },
    legalBasis: {
      title: 'Base légale',
      description:
        "Le traitement de vos données est basé sur : (1) l'exécution d'un contrat pour les groupes, (2) votre consentement pour les spectateurs, (3) notre intérêt légitime pour la sécurité et la prévention de la fraude.",
    },
    retention: {
      title: 'Durée de conservation',
      active:
        "Données de compte actif : conservées pendant toute la durée d'utilisation du service",
      inactive: "Données de compte inactif : supprimées après 3 ans d'inactivité",
      legal:
        'Données nécessaires à des obligations légales : conservées selon les durées légales applicables',
    },
    rights: {
      title: 'Vos droits',
      description: 'Conformément au RGPD, vous disposez des droits suivants :',
      access: "Droit d'accès : consulter vos données personnelles",
      rectification: 'Droit de rectification : corriger vos données inexactes',
      deletion: "Droit à l'effacement : supprimer vos données (droit à l'oubli)",
      portability: 'Droit à la portabilité : récupérer vos données dans un format structuré',
      opposition: "Droit d'opposition : vous opposer au traitement de vos données",
      limitation: 'Droit à la limitation : limiter le traitement de vos données',
      contact:
        'Pour exercer vos droits, contactez-nous à : contact@axialdata.net. Vous pouvez aussi exporter ou supprimer vos données depuis Paramètres du compte.',
    },
    security: {
      title: 'Sécurité des données',
      description:
        'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte, destruction ou altération. Les données sont stockées sur des serveurs sécurisés et les communications sont chiffrées.',
    },
    cookies: {
      title: 'Cookies et traceurs',
      description:
        "Notre application utilise des cookies essentiels pour le fonctionnement du service. Pour plus d'informations, consultez notre politique des cookies.",
      link: 'Politique des cookies',
    },
    contact: {
      title: 'Contact',
      description: 'Pour toute question concernant cette politique ou vos données personnelles :',
      email: 'contact@axialdata.net',
    },
  },
  cookies: {
    title: 'Politique des cookies',
    intro: {
      title: 'Introduction',
      description:
        "Cette page vous informe sur l'utilisation des cookies et technologies similaires sur PlayItNow.",
    },
    essential: {
      title: 'Cookies essentiels',
      description:
        'Les cookies suivants sont strictement nécessaires au fonctionnement du service et ne nécessitent pas de consentement préalable :',
      accessToken: {
        title: 'access_token',
        description:
          "Cookie d'authentification permettant de maintenir votre session connectée. Ce cookie est httpOnly (non accessible via JavaScript) et sécurisé.",
        duration: 'Durée : 15 minutes',
      },
      refreshToken: {
        title: 'refresh_token',
        description:
          'Cookie permettant de renouveler automatiquement votre session. Ce cookie est httpOnly et sécurisé.',
        duration: 'Durée : 7 jours',
      },
      csrfToken: {
        title: 'csrf_token',
        description:
          'Cookie de protection contre les attaques CSRF (Cross-Site Request Forgery). Ce cookie est accessible via JavaScript pour validation côté client.',
        duration: 'Durée : 7 jours',
      },
    },
    localStorage: {
      title: 'Stockage local (localStorage)',
      description:
        'Nous utilisons également le stockage local de votre navigateur pour mémoriser vos préférences :',
      theme: "Thème d'affichage (mode clair/sombre)",
      lang: 'Langue préférée',
      firstname: 'Prénom (pour affichage lors des votes)',
      fingerprint: 'Empreinte numérique du navigateur (anti-fraude)',
    },
    analytics: {
      title: 'Mesure d\'audience (Rybbit)',
      description:
        'Lorsque la mesure d\'audience est activée (production), un script Rybbit, hébergé sur nos propres serveurs (analytics.axialdata.app), envoie des données minimales (pages vues, provenance) pour analyser l\'usage du site, à usage strictement interne. Aucune publicité, aucune revente ni cession de données à des tiers. Ce traitement repose sur notre intérêt légitime. Rybbit peut utiliser un identifiant technique (cookie ou stockage local) pour dédupliquer les visites. Vous pouvez bloquer les scripts tiers via votre navigateur pour désactiver ce suivi.',
    },
    management: {
      title: 'Gestion des cookies',
      description:
        "Vous pouvez gérer les cookies via les paramètres de votre navigateur. Notez que la désactivation des cookies essentiels empêchera le bon fonctionnement de l'application.",
    },
  },
  terms: {
    title: "Conditions Générales d'Utilisation",
    lastUpdated: 'Dernière mise à jour : octobre 2025',
    intro: {
      title: 'Article 1 - Objet',
      description:
        "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation du service PlayItNow, une plateforme SaaS permettant aux groupes de musique de proposer une expérience interactive à leur public lors de concerts. Ces CGU s'appliquent à la fois aux groupes (clients payants) et aux spectateurs (utilisateurs gratuits).",
    },
    service: {
      title: 'Article 2 - Description du service',
      description:
        "PlayItNow est une application web permettant aux groupes de musique de créer des événements, de gérer une bibliothèque de morceaux, et de permettre au public de voter pour les morceaux qu'ils souhaitent entendre. Le service est payant pour les groupes et gratuit pour les spectateurs.",
    },
    forBands: {
      title: 'Article 3 - Conditions spécifiques aux groupes',
      subtitle:
        "Les conditions suivantes s'appliquent uniquement aux groupes utilisant le service en tant que clients payants :",
      registration: {
        title: '3.1 - Inscription et compte',
        description:
          'Pour utiliser le service en tant que groupe, vous devez créer un compte en fournissant des informations exactes et à jour. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées depuis votre compte.',
      },
      subscription: {
        title: '3.2 - Abonnements et tarification',
        description:
          "L'accès au service pour les groupes est soumis à un abonnement payant. Les tarifs, formules et conditions d'abonnement sont disponibles sur la plateforme. Les abonnements sont renouvelés automatiquement sauf résiliation de votre part.",
      },
      payment: {
        title: '3.3 - Paiement',
        description:
          "Les paiements sont effectués via un prestataire de paiement sécurisé. En cas de défaut de paiement, l'accès au service peut être suspendu. Aucun remboursement n'est dû en cas de résiliation anticipée, sauf disposition légale contraire.",
      },
      obligations: {
        title: '3.4 - Obligations',
        customer: {
          title: '3.4.1 - Obligations du client',
          accuracy: 'Fournir des informations exactes et à jour',
          security: 'Maintenir la confidentialité de vos identifiants',
          compliance: 'Respecter les lois et réglementations applicables',
          prohibited: 'Ne pas utiliser le service à des fins illégales ou frauduleuses',
        },
        provider: {
          title: '3.4.2 - Obligations du prestataire',
          availability: 'Assurer la disponibilité du service dans la mesure du possible',
          support: 'Fournir un support technique dans les limites du service',
          security: 'Mettre en œuvre des mesures de sécurité appropriées',
        },
      },
      intellectualProperty: {
        title: '3.5 - Propriété intellectuelle',
        description:
          "Tous les éléments du service PlayItNow (code, design, marques, etc.) sont la propriété exclusive d'axialdata. L'utilisation du service ne confère aucun droit de propriété sur ces éléments.",
      },
      termination: {
        title: '3.6 - Résiliation',
        description:
          'Vous pouvez résilier votre abonnement à tout moment depuis votre espace client. axialdata se réserve le droit de suspendre ou résilier tout compte en cas de non-respect des présentes CGU.',
      },
      jurisdiction: {
        title: '3.7 - Droit applicable et juridiction',
        description:
          'Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français sont seuls compétents.',
      },
    },
    forSpectators: {
      title: 'Article 4 - Conditions spécifiques aux spectateurs',
      subtitle:
        "Les conditions suivantes s'appliquent uniquement aux spectateurs utilisant le service gratuitement :",
      voting: {
        title: '4.1 - Système de vote',
        description: 'Lors de votre participation à un événement, vous pouvez :',
        rules: {
          one: 'Voter pour un ou plusieurs morceaux selon les règles définies par le groupe',
          fraud: 'Respecter les limites de vote pour éviter toute fraude',
          respect: 'Utiliser le service de manière respectueuse et conforme à son objet',
        },
      },
      account: {
        title: '4.2 - Compte utilisateur',
        description:
          "La création d'un compte est optionnelle. Vous pouvez participer de manière anonyme en fournissant uniquement un prénom. Si vous créez un compte, vous êtes responsable de la confidentialité de vos identifiants.",
      },
      conduct: {
        title: '4.3 - Règles de conduite',
        description: 'Il est strictement interdit de :',
        prohibited: {
          fraud: 'Tenter de frauder le système de vote',
          abuse: 'Utiliser le service de manière abusive ou malveillante',
          illegal: 'Utiliser le service à des fins illégales',
        },
      },
      privacy: {
        title: '4.4 - Données personnelles',
        description:
          'Le traitement de vos données personnelles est régi par notre politique de confidentialité. En utilisant le service, vous acceptez cette politique.',
        link: 'Consulter notre politique de confidentialité',
      },
    },
    liability: {
      title: 'Article 5 - Responsabilité',
      description:
        "axialdata ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation ou de l'impossibilité d'utiliser le service. Pour les groupes, la responsabilité est limitée au montant des sommes versées au titre de l'abonnement. Pour les spectateurs, le service est fourni \"en l'état\" sans garantie d'aucune sorte.",
    },
    modifications: {
      title: 'Article 6 - Modifications',
      description:
        'axialdata se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur publication. Votre utilisation continue du service vaut acceptation des nouvelles conditions.',
    },
    contact: {
      title: 'Article 7 - Contact',
      description: 'Pour toute question concernant les présentes CGU :',
      email: 'contact@axialdata.net',
    },
  },
  cookieBanner: {
    message:
      'Ce site utilise des cookies essentiels et une mesure d\'audience (anonyme, à usage strictement interne). En continuant à naviguer, vous acceptez leur utilisation.',
    learnMore: 'En savoir plus sur les cookies',
    accept: "J'accepte",
  },
  footer: {
    legal: 'Mentions légales',
    privacy: 'Confidentialité',
    cookies: 'Cookies',
    terms: 'CGU',
  },
  errors: {
    EVENT_NOT_AVAILABLE_YET:
      "Cet événement n'est pas encore disponible. Revenez à la date et l'heure prévues pour accéder au vote.",
    networkError:
      'Impossible de joindre le serveur. Vérifiez votre connexion ou réessayez plus tard.',
    unexpectedError: 'Une erreur inattendue s\'est produite. Veuillez réessayer plus tard.',
    validationError: 'Données invalides. Vérifiez le formulaire.',
    badRequest: 'Requête invalide.',
    unauthorized: 'Authentification requise.',
    forbidden: 'Accès refusé.',
    notFound: 'Ressource introuvable.',
    invalidJsonBody: 'Format de données invalide.',
    invalidCredentials: 'Identifiants incorrects.',
    emailAlreadyRegistered: 'Cette adresse email est déjà utilisée.',
    notAuthenticated: 'Vous devez être connecté.',
    tokenRequired: 'Lien invalide ou expiré.',
    ONE_SHOW_DATE_OUT_OF_RANGE:
      "La date de l'événement ONE_SHOW doit être comprise entre la date d'achat et +30 jours",
  },
  common: {
    copyright: 'Tous droits réservés',
    year: new Date().getFullYear().toString(),
    company: 'axialdata',
    required: 'Requis',
    back: 'Retour',
    goHome: "Retour à l'accueil",
    close: 'Fermer',
    cancel: 'Annuler',
    selectLanguage: 'Sélectionner la langue',
    skipToContent: 'Aller au contenu principal',
    activateDarkMode: 'Activer le mode sombre',
    activateLightMode: 'Activer le mode clair',
    loading: 'Chargement...',
    processing: 'Traitement...',
    logoUrlExpiringModalTitle: 'URL d’image susceptible d’expirer',
    logoUrlExpiringModalMessage:
      'Cette adresse pointe vers un hébergeur (ex. Facebook) dont les liens images peuvent devenir invalides avec le temps. L’image pourrait ne plus s’afficher plus tard. Vous pouvez tout de même enregistrer cette URL si vous le souhaitez.',
    ok: 'OK',
  },
  pwa: {
    install: {
      button: "Installer l'application",
      installButton: 'Installer',
      promptDescription: 'Installez PlayItNow sur votre appareil pour une meilleure expérience',
      waiting: "En attente de l'autorisation d'installation...",
      iosButton: 'Installer sur iOS',
      iosTitle: 'Installer PlayItNow sur votre iPhone/iPad',
      iosStep1: "1. Appuyez sur le bouton de partage en bas de l'écran",
      iosStep2: '2. Faites défiler et sélectionnez "Sur l\'écran d\'accueil"',
      iosStep3: '3. Appuyez sur "Ajouter" pour installer l\'application',
    },
  },
  forgotPassword: {
    title: 'Mot de passe oublié',
    subtitle: 'Entrez votre adresse email pour recevoir un lien de réinitialisation',
    emailLabel: 'Adresse email',
    emailPlaceholder: 'votre@email.com',
    submitButton: 'Envoyer le lien de réinitialisation',
    submitting: 'Envoi en cours...',
    successMessage: 'Si un compte avec cet email existe, un lien de réinitialisation a été envoyé.',
    backToLogin: 'Retour à la connexion',
    errorGeneric: 'Une erreur est survenue',
  },
  resetPassword: {
    title: 'Réinitialiser le mot de passe',
    subtitle: 'Entrez votre nouveau mot de passe',
    passwordLabel: 'Nouveau mot de passe',
    passwordPlaceholder: '••••••••',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: '••••••••',
    submitButton: 'Réinitialiser le mot de passe',
    submitting: 'Réinitialisation...',
    successMessage:
      'Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    backToLogin: 'Retour à la connexion',
    errorGeneric: 'Une erreur est survenue lors de la réinitialisation',
    invalidToken: 'Le lien de réinitialisation est invalide ou a expiré',
  },
  confirmEmail: {
    title: 'Confirmer votre adresse email',
    setPasswordTitle: 'Définir votre mot de passe',
    setPasswordSubtitle: 'Choisissez un mot de passe pour finaliser votre inscription.',
    passwordLabel: 'Mot de passe',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    submitButton: 'Activer mon compte',
    confirming: 'Confirmation en cours…',
    successFan: 'Compte activé. Redirection…',
    successBand: 'Compte créé. Redirection…',
    alreadyCompleted: 'Inscription déjà finalisée ou lien expiré. Veuillez vous connecter.',
    goToLogin: 'Aller à la connexion',
    invalidToken: 'Lien invalide ou expiré. Veuillez vous réinscrire ou demander un nouvel email.',
    missingToken: 'Lien de confirmation manquant.',
    errorGeneric: 'Une erreur est survenue.',
    backToRegister: 'Retour à l’inscription',
  },
  admin: {
    nav: {
      dashboard: 'Tableau de bord',
      events: 'Événements',
      songs: 'Morceaux',
      venues: 'Lieux',
      members: 'Membres',
      settings: 'Paramètres',
      userSettings: 'Mon compte',
      logout: 'Déconnexion',
    },
    dashboard: {
      welcome: 'Bienvenue',
      bandName: 'Groupe',
      superadminMode: 'Mode Super Administrateur',
      totalEvents: 'Total événements',
      activeEvents: 'Événements actifs',
      upcomingEvents: 'Événements à venir',
      quickActions: 'Actions rapides',
      createEvent: 'Créer un événement',
      manageVenues: 'Gérer les lieux',
      recentEvents: 'Événements récents',
      viewAll: 'Voir tout',
      noEvents: 'Aucun événement pour le moment',
      createFirstEvent: 'Créer votre premier événement',
      noVenue: 'Aucun lieu',
      errorLoad: 'Erreur lors du chargement des données',
      status: {
        pending: 'En attente',
        active: 'Actif',
        completed: 'Terminé',
      },
    },
    planBadge: {
      tooltip: 'Plan actuel — Cliquez pour gérer votre abonnement',
      ariaLabel: 'Voir et gérer votre abonnement',
    },
    oneShowAlert: {
      title: "Validité de l'événement OneShow",
      daysRemaining: '{{days}} jour(s) restant(s)',
      daysShort: '{{days}}j',
      daysRemainingMessage:
        'Il vous reste {{days}} jour(s) pour utiliser cet événement en mode illimité.',
      urgentTitle: 'Expiration imminente',
      expired: 'Événement OneShow expiré',
      expiredShort: 'Expiré',
      expiredMessage:
        'Cet événement a atteint la fin de sa période de validité. Passez à ProGig pour des événements illimités.',
      upgradeCta: 'Voir les formules',
    },
    subscription: {
      plan: {
        FREE: 'Free',
        PRO_GIG: 'ProGig',
        LIVE_TOUR: 'LiveTour',
        ONE_SHOW: 'OneShow',
      },
      title: 'Abonnement',
      subtitle: 'Gérez la formule de votre groupe et vos limites d’utilisation',
      currentPlan: 'Formule actuelle',
      currentPlanFree: 'Gratuit (FREE)',
      currentPlanProGig: 'ProGig',
      currentPlanLiveTour: 'LiveTour',
      freeDescription: 'Parfait pour découvrir et tester le service.',
      proGigDescription: 'Formule pour les groupes avec plusieurs concerts par mois.',
      liveTourDescription: 'Formule pour les tournées intensives et les usages illimités.',
      chooseProGig: 'Passer à ProGig',
      chooseLiveTour: 'Passer à LiveTour',
      loading: 'Chargement de votre abonnement...',
      errorLoad: 'Erreur lors du chargement de votre abonnement.',
      errorCheckout:
        'Erreur lors de la création de la session de paiement Stripe. Merci de réessayer dans quelques instants.',
      successTitle: 'Paiement réussi',
      successMessage:
        'Votre paiement a été pris en compte. Votre abonnement sera mis à jour dans quelques instants.',
      successRedirect: 'Vous allez être redirigé vers votre tableau de bord.',
      monthlyQuota: 'Quota mensuel',
      freeQuota: 'Quota gratuit',
      eventsUsed: '{{current}} / {{limit}} événements',
      billingPeriod: 'Période : {{start}} - {{end}}',
      quotaReached: 'Quota mensuel atteint',
      quotaReachedMessage:
        "Vous avez atteint votre limite d'événements pour cette période. Le quota sera réinitialisé à la fin de votre période de facturation.",
      quotaWarning: 'Quota mensuel presque atteint',
      quotaWarningMessage: 'Il vous reste {{remaining}} événement(s) pour cette période.',
      quotaInfo: 'Il vous reste {{remaining}} événement(s) pour cette période.',
      upgradePlan: 'Passer au plan supérieur',
      upgradeToUnlimited: 'Passer en illimité',
      upgradeSingleEventConfirm:
        "Vous êtes sur le point de passer l'événement « {{eventName}} » en illimité.",
      singleEventDescription:
        "Il s'agit d'un paiement unique pour un nombre illimité de votes pour cet événement spécifique.",
      oneShowValidity: "Valable {{days}} jours à partir de l'achat.",
      oneShowNonRefundable:
        'Paiement non remboursable : une fois effectué, le paiement ne pourra pas être annulé ou remboursé.',
      multipleProGigSuggestion:
        'Plusieurs événements ? Le plan ProGig pourrait être plus avantageux.',
      comparePlans: 'Comparer les formules →',
      upgradeToUnlimitedNow: 'Passer en illimité maintenant',
      checkoutError: 'Erreur lors de la création de la session de paiement. Merci de réessayer.',
      oneShowPrice: 'Prix',
      oneShowPaymentType: 'Paiement unique',
      oneShowBenefitsTitle: 'Ce que vous obtenez :',
      oneShowBenefitVotes: 'Votes illimités pour cet événement',
      oneShowBenefitTime: "Aucune limite de temps d'activation",
      chooseOption: 'Choisir une option',
      convertEvent: 'Convertir un événement',
      createEvent: 'Créer un événement',
      selectFreeEvent: 'Sélectionnez un événement gratuit à convertir :',
      convertThisEvent: 'Convertir cet événement',
      noFreeEventsToConvert: "Aucun événement gratuit à convertir. Créez d'abord un événement.",
      createDescription: 'Créez un nouvel événement avec le plan Événement unique.',
      createNewOneShot: 'Créer un événement unique',
      createOneShotEventTitle: 'Créer un événement unique',
      proceedToPayment: 'Procéder au paiement',
      oneShowDescription: 'Un paiement unique pour un événement en illimité (votes illimités).',
      configureOneShot: 'Configurer',
      convertEventFromUrl: "L'événement « {{name}} » sera converti en événement unique.",
      priceFree: 'Gratuit',
      priceOneTime: '{{price}}€ (paiement unique)',
      pricePerMonth: '{{price}}€ / mois',
      currentPlanBadge: 'Plan actuel',
      selectPlan: 'Choisir',
      planFree: 'Gratuit',
      featureMaxEvents: 'Événements maximum',
      featureMaxVotes: 'Votes par événement',
      featureActiveTime: "Temps d'activation cumulé",
      featureEventsPerMonth: 'Événements par mois',
      featureOneEvent: '1 événement (unique)',
      featureValidity: 'Validité',
      validityDays: '{{days}} jours',
      unlimited: 'Illimité',
      events: 'événements',
      votes: 'votes',
      minutes: 'min',
      planNote: {
        FREE: "5 événements max (hors OneShow). 8 votes par événement. 40 min d'activation cumulées.",
        ONE_SHOW:
          'Paiement unique. Un événement en illimité (votes illimités, sans limite de temps).',
        PRO_GIG: '3 événements par mois (période glissante selon facturation Stripe).',
        LIVE_TOUR: 'Événements illimités. Idéal pour les tournées.',
      },
      cancelSubscriptionButton: "Annuler l'abonnement",
      cancelSubscriptionConfirmTitle: "Résilier l'abonnement",
      cancelSubscriptionConfirmMessage:
        "Aucun remboursement. Votre abonnement reste actif jusqu'au {{date}} (fin de la période déjà payée), puis vous repassez au plan gratuit. Continuer ?",
      cancelSubscriptionSuccess: "Abonnement résilié. Vous conservez l'accès jusqu'au {{date}}.",
      cancelSubscriptionError: "Erreur lors de l'annulation de l'abonnement.",
      accessUntil: "Accès jusqu'au {{date}}",
      cancellationScheduled: 'Résiliation programmée',
      cancelling: 'Annulation...',
    },
    events: {
      title: 'Événements',
      subtitle: 'Gérez vos concerts et événements',
      eventsList: 'Liste des événements',
      upcomingEvents: 'Événements à venir',
      pastEvents: 'Événements passés',
      noEvents: 'Aucun événement pour le moment',
      addEvent: 'Créer un événement',
      add: 'Créer',
      adding: 'Création...',
      edit: 'Modifier',
      editing: 'Modification...',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirmDeleteTitle: 'Supprimer un événement',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer l\'événement "{{name}}" ?',
      name: "Nom de l'événement",
      namePlaceholder: 'Ex: Concert au Zénith',
      venue: 'Lieu',
      selectVenue: 'Sélectionner un lieu',
      date: 'Date',
      time: 'Heure',
      oneShowDateRestriction: "Date verrouillée : entre l'achat et +{{days}} jours",
      maxVotesPerUser: 'Votes maximum par utilisateur',
      maxVotes: 'Votes max',
      tiebreaker: 'Gestion des égalités',
      tiebreakerChronological: 'Chronologique (premier voté)',
      tiebreakerRandom: 'Aléatoire',
      tiebreakerManual: 'Manuel (choix du groupe)',
      showRanking: 'Afficher le classement',
      showRankingToPublic: 'Afficher le classement aux spectateurs',
      blindVote: "Vote à l'aveugle",
      status: {
        pending: 'En attente',
        active: 'Actif',
        completed: 'Terminé',
      },
      planBadge: {
        subscription: 'Abonnement (illimité)',
        oneShow: 'OneShow (événement illimité)',
      },
      addSuccess: 'Événement créé avec succès',
      addError: "Erreur lors de la création de l'événement",
      updateSuccess: 'Événement modifié avec succès',
      updateError: "Erreur lors de la modification de l'événement",
      deleteSuccess: 'Événement supprimé avec succès',
      deleteError: "Erreur lors de la suppression de l'événement",
      errorLoad: 'Erreur lors du chargement des événements',
      noVenues: 'Vous devez créer au moins un lieu avant de créer un événement',
      qrCodeTitle: 'Code QR généré',
      qrCodeDescription: 'Utilisez ce code pour permettre aux spectateurs de voter',
      copyQRCode: 'Copier le code QR',
      qrCodeCopied: 'Code QR copié dans le presse-papiers',
      showQRCode: 'Afficher le QR code',
      qrCodePrint: 'Imprimer',
      qrCodeShare: 'Partager',
      qrCodeDownload: 'Télécharger',
      qrCodeUrl: "URL de l'événement",
      qrCodeShareText: 'Rejoignez-moi pour voter sur les morceaux de {{eventName}} !',
      qrCodePrintTitle: 'QR Code - PlayItNow',
      qrCodePrintInstructions:
        "Scannez ce code QR pour accéder à l'événement et voter pour vos morceaux préférés. Les titres gagnants seront joués en live !",
      delete: 'Supprimer',
      activate: 'Activer',
      deactivate: 'Désactiver',
      complete: 'Terminer',
      reactivate: 'Réactiver',
      activateSuccess: 'Événement activé avec succès',
      activateError: "Erreur lors de l'activation de l'événement",
      deactivateSuccess: 'Événement désactivé avec succès',
      deactivateError: "Erreur lors de la désactivation de l'événement",
      completeSuccess: 'Événement terminé avec succès',
      completeError: "Erreur lors de la finalisation de l'événement",
      showRankingBtn: 'Afficher le classement aux spectateurs',
      hideRankingBtn: 'Masquer le classement aux spectateurs',
      rankingHidden: 'Classement masqué aux spectateurs',
      rankingVisible: 'Classement visible par les spectateurs',
      toggleBlindVoteError: 'Erreur lors du changement de visibilité du classement',
      live: {
        title: 'Dashboard Live',
        loading: 'Chargement...',
        errorLoad: 'Erreur lors du chargement',
        errorToggle: 'Erreur lors du changement de visibilité',
        errorMarkPlayed: 'Erreur lors du marquage',
        eventNotFound: 'Événement non trouvé',
        backToEvents: 'Retour aux événements',
        totalVotes: 'Votes totaux',
        uniqueVoters: 'Votants uniques',
        songsPlayed: 'Morceaux joués',
        noVotesYet: 'Aucun vote pour le moment',
        noVotes: 'Pas encore de votes',
        rankingHidden: 'Classement masqué',
        rankingVisible: 'Classement visible',
        markPlayed: 'Marquer comme joué',
        unmarkPlayed: 'Annuler le marquage',
        autoRefresh: 'Actualisation auto',
        openLive: 'Ouvrir le Live',
      },
      songs: {
        title: "Morceaux de l'événement",
        subtitle: 'Gérez les morceaux disponibles pour le vote',
        addSong: 'Ajouter un morceau',
        searchExisting: 'Rechercher un morceau existant',
        searchPlaceholder: 'Rechercher par titre ou artiste...',
        noResults: 'Aucun morceau trouvé',
        or: 'OU',
        songTitle: 'Titre',
        titlePlaceholder: 'Ex: Bohemian Rhapsody',
        artist: 'Artiste',
        artistPlaceholder: 'Ex: Queen',
        duration: 'Durée',
        durationPlaceholder: 'Ex: 5:55',
        year: 'Année',
        yearPlaceholder: 'Ex: 2020',
        add: 'Ajouter',
        adding: 'Ajout...',
        remove: 'Retirer',
        noSongs: 'Aucun morceau pour cet événement',
        addSuccess: 'Morceau ajouté avec succès',
        addError: "Erreur lors de l'ajout du morceau",
        createSuccess: 'Morceau créé et ajouté avec succès',
        createError: 'Erreur lors de la création du morceau',
        removeSuccess: 'Morceau retiré avec succès',
        removeError: 'Erreur lors du retrait du morceau',
        errorLoad: 'Erreur lors du chargement des morceaux',
        copyFromEvent: 'Copier depuis un autre événement',
        copyModal: {
          title: 'Copier la liste de morceaux',
          description:
            'Sélectionnez un événement pour copier sa liste de morceaux dans cet événement.',
          noEvents: 'Aucun autre événement disponible',
        },
        copySuccess: 'Morceaux copiés avec succès',
        copySuccessCount: 'morceau(s) ajouté(s)',
        copySkipped: 'déjà présent(s)',
        copyNoSongs: "L'événement sélectionné ne contient aucun morceau",
        copyAllAlreadyAdded: 'Tous les morceaux de cet événement sont déjà présents',
        copyError: 'Erreur lors de la copie des morceaux',
      },
    },
    songs: {
      title: 'Bibliothèque de morceaux',
      subtitle: 'Gérez votre répertoire de morceaux',
      songsList: 'Liste des morceaux',
      noSongs: 'Aucun morceau pour le moment',
      addSong: 'Ajouter un morceau',
      add: 'Ajouter',
      adding: 'Ajout...',
      edit: 'Modifier',
      editing: 'Modification...',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirmDeleteTitle: 'Supprimer un morceau',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer "{{title}}" de {{artist}} ?',
      songTitle: 'Titre',
      titlePlaceholder: 'Ex: Bohemian Rhapsody',
      artist: 'Artiste',
      artistPlaceholder: 'Ex: Queen',
      duration: 'Durée',
      durationPlaceholder: 'Ex: 5:55',
      durationFormat: 'Format: MM:SS (ex: 3:45)',
      year: 'Année',
      yearPlaceholder: 'Ex: 2020',
      addSuccess: 'Morceau ajouté avec succès',
      addError: "Erreur lors de l'ajout du morceau",
      updateSuccess: 'Morceau modifié avec succès',
      updateError: 'Erreur lors de la modification du morceau',
      deleteSuccess: 'Morceau supprimé avec succès',
      deleteError: 'Erreur lors de la suppression du morceau',
      errorLoad: 'Erreur lors du chargement des morceaux',
      delete: 'Supprimer',
    },
    settings: {
      title: 'Paramètres du groupe',
      subtitle: 'Gérez les informations de votre groupe',
      bandName: 'Nom du groupe',
      bandNamePlaceholder: 'Nom de votre groupe',
      logoUrl: 'URL du logo',
      logoUrlPlaceholder: 'https://example.com/logo.png',
      logoPreview: 'Aperçu du logo',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      successMessage: 'Paramètres enregistrés avec succès',
      errorLoad: 'Erreur lors du chargement des paramètres',
      errorSave: "Erreur lors de l'enregistrement des paramètres",
    },
    userSettings: {
      title: 'Mon compte',
      account: 'Informations du compte',
      email: 'Email',
      username: "Nom d'utilisateur",
      firstName: 'Prénom',
      lastName: 'Nom',
      save: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      success: 'Paramètres du compte mis à jour avec succès',
      error: 'Erreur lors de la mise à jour du compte',
      password: {
        title: 'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        currentPasswordPlaceholder: '••••••••',
        newPassword: 'Nouveau mot de passe',
        newPasswordPlaceholder: '••••••••',
        confirmPassword: 'Confirmer le nouveau mot de passe',
        confirmPasswordPlaceholder: '••••••••',
        change: 'Changer le mot de passe',
        changing: 'Changement en cours...',
        success: 'Mot de passe changé avec succès. Veuillez vous reconnecter.',
        error: 'Erreur lors du changement de mot de passe',
        mismatch: 'Les mots de passe ne correspondent pas',
        incorrect: 'Le mot de passe actuel est incorrect',
      },
      deleteAccount: {
        title: 'Supprimer le compte',
        description:
          'La suppression de votre compte est une action irréversible. Toutes vos données seront perdues.',
        button: 'Supprimer mon compte',
        confirmTitle: 'Confirmer la suppression',
        confirmMessage:
          'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
        confirmButton: 'Oui, supprimer',
        cancelButton: 'Annuler',
        confirming: 'Suppression...',
        error: 'Erreur lors de la suppression du compte',
      },
    },
    members: {
      title: 'Membres du groupe',
      subtitle: 'Gérez les membres de votre groupe',
      membersList: 'Liste des membres',
      noMembers: 'Aucun membre pour le moment',
      inviteMember: 'Inviter un membre',
      invite: 'Inviter',
      inviting: 'Invitation...',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirmRemoveTitle: 'Retirer un membre',
      confirmToggleOwnerTitle: 'Modifier le statut propriétaire',
      email: 'Email',
      emailPlaceholder: 'membre@example.com',
      password: 'Mot de passe',
      passwordPlaceholder: 'Minimum 8 caractères',
      firstName: 'Prénom',
      firstNamePlaceholder: 'Prénom (optionnel)',
      lastName: 'Nom',
      lastNamePlaceholder: 'Nom (optionnel)',
      owner: 'Propriétaire',
      invitedBy: 'Invité par',
      remove: 'Retirer',
      confirmRemove: 'Êtes-vous sûr de vouloir retirer {{email}} du groupe ?',
      inviteSuccess: 'Membre invité avec succès',
      inviteError: "Erreur lors de l'invitation",
      removeSuccess: 'Membre retiré avec succès',
      removeError: 'Erreur lors du retrait du membre',
      errorLoad: 'Erreur lors du chargement des membres',
      promote: 'Promouvoir propriétaire',
      demote: 'Rétrograder',
      confirmToggleOwner: 'Êtes-vous sûr de vouloir {{action}} ce membre ?',
      promoteSuccess: 'Membre promu propriétaire avec succès',
      demoteSuccess: 'Membre rétrogradé avec succès',
      toggleOwnerError: 'Erreur lors de la modification du statut',
    },
    venues: {
      title: 'Lieux de concert',
      subtitle: 'Gérez les lieux où vous jouez',
      venuesList: 'Liste des lieux',
      noVenues: 'Aucun lieu pour le moment',
      addVenue: 'Ajouter un lieu',
      add: 'Ajouter',
      adding: 'Ajout...',
      edit: 'Modifier',
      editing: 'Modification...',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirmDeleteTitle: 'Supprimer un lieu',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer le lieu "{{name}}" ?',
      name: 'Nom du lieu',
      namePlaceholder: 'Ex: Le Zénith',
      address: 'Adresse',
      addressPlaceholder: 'Ex: 211 Avenue Jean Jaurès',
      city: 'Ville',
      cityPlaceholder: 'Ex: Paris',
      country: 'Pays',
      countryPlaceholder: 'Ex: France',
      googleMapsUrl: 'Lien Google Maps',
      googleMapsUrlPlaceholder: 'Ex: https://maps.google.com/...',
      generateMapsUrl: 'Générer le lien Google Maps',
      generateMapsUrlError: 'Saisissez au moins le nom du lieu ou la ville pour générer le lien.',
      viewOnGoogleMaps: 'Voir sur Google Maps',
      addSuccess: 'Lieu ajouté avec succès',
      addError: "Erreur lors de l'ajout du lieu",
      updateSuccess: 'Lieu modifié avec succès',
      updateError: 'Erreur lors de la modification du lieu',
      deleteSuccess: 'Lieu supprimé avec succès',
      deleteError: 'Erreur lors de la suppression du lieu',
      errorLoad: 'Erreur lors du chargement des lieux',
    },
  },
  notFound: {
    title: 'Page introuvable',
    subtitle: "Oups ! Cette page n'existe pas",
    description: 'La page que vous recherchez a peut-être été déplacée ou supprimée.',
    quickLinks: 'Liens rapides',
    goHome: "Retour à l'accueil",
    goToLogin: 'Aller à la connexion',
    helpText: "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le support.",
  },
}
